import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBookingsInitialState, IBookingsList } from '@types';

import { initialBookings } from './initialState';

export const bookingsSlice = createSlice({
    name: 'bookings',
    initialState: initialBookings(),
    reducers: {
        setBookings(state: IBookingsInitialState, action: PayloadAction<IBookingsList>) {
            state.bookingsList = action.payload;
        },
    },
});
